import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AuthService } from '../../services/auth.service';
import { noop, tap } from 'rxjs';
import { NtError } from '../../models/auth-models';
import { MatIconModule } from '@angular/material/icon';
import { ClimateToggleComponent } from '../../../../theme/climate-toggle.component';
import { PalettePickerComponent } from '../../../../theme/palette-picker.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SNACKBAR_DURATION, APP_VERSION, IS_PROD } from '../../../constants';

const materialModules = [
  FormsModule,
  CommonModule,
  MatCardModule,
  MatInputModule,
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  ClimateToggleComponent,
  PalettePickerComponent,
  MatDividerModule,
  NgOptimizedImage,
  MatProgressSpinnerModule,
];

@Component({
  selector: 'nt-login',
  standalone: true,
  imports: [materialModules],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class LoginComponent {
  private readonly _authService = inject(AuthService);
  readonly router = inject(Router);
  private readonly _snackBar = inject(MatSnackBar);

  public isProd: boolean = IS_PROD;
  public version: string = APP_VERSION;
  public loading =  signal(false);
  public hidePassword = signal(true);
  user: string = '';
  password: string = '';
  loginValid: boolean = true;
  year: number = new Date().getFullYear();

  togglePasswordVisibility(): void {
    this.hidePassword.update((hidden) => !hidden);
  }

  login(): void {
    this.loading.set(true);
    this._authService
      .$login(this.user, this.password)
      .pipe(
        tap((response) => {
          this.loading.set(false);
          this.router.navigateByUrl('/portal/dashboard');
        })
      )
      .subscribe(noop, (error: NtError) => {
        this.loading.set(false);
        this._snackBar.open('Error de inicio de sesión: ' + error.message, 'Cerrar', { duration: SNACKBAR_DURATION, panelClass: ['snackbar-error'] });
      });
  }
}
